import React from 'react';
import { Laptop, Atom, Palette, Wrench, Globe, Rocket, ShoppingCart, Home, ShoppingBag } from 'lucide-react';

export const SITE_CONFIG = {
    title: 'Mowli S | Full Stack Software Developer | Web & Mobile Apps',
    description: 'Looking for a Full Stack Software Developer? Mowli S specializes in React.js, Next.js, Node.js, PHP, React Native, Expo, and building custom web and mobile applications.',
    author: 'Mowli S',
    url: process.env.REACT_APP_SITE_URL || 'https://mowli.in',
    email: process.env.REACT_APP_CONTACT_EMAIL || 'mowlisellappan62@gmail.com',
    phone: process.env.REACT_APP_CONTACT_PHONE || '+91 88700 20639',
    whatsapp: process.env.REACT_APP_WHATSAPP_PHONE || '8870020639',
    social: {
        github: process.env.REACT_APP_GITHUB_URL || 'https://github.com/MOWLI17',
        linkedin: process.env.REACT_APP_LINKEDIN_URL || 'https://www.linkedin.com/in/mowli-s',
        twitter: process.env.REACT_APP_TWITTER_URL || '@mowli'
    }
};

export const NAV_LINKS = [
    { id: 'home', label: 'HOME', href: '#home' },
    { id: 'about', label: 'ABOUT', href: '#about' },
    { id: 'experience', label: 'EXPERIENCE', href: '#experience' },
    { id: 'services', label: 'SERVICES', href: '#services' },
    { id: 'projects', label: 'PROJECTS', href: '#projects' },
    { id: 'contact', label: 'CONTACT', href: '#contact' },
];

export const ANIMATION_CONFIG = {
    cursorSpeed: 0.35,//
    scrollThreshold: 300,
};

// EMAILJS_CONFIG removed for security (Backend implementation used)

export const EXPERIENCE_DATA = [
    {
        id: 1,
        role: "Associate IT Manager / Frontend Developer",
        company: "Workfreaks",
        duration: "Oct 2024 – Present",
        description: "Developing scalable, high-performance web applications using React.js. Focused on reusable components, API integration, and performance optimization in an Agile environment.",
        descriptionMobile: "Developing scalable web apps using React.js, focusing on reusable components and performance."
    }
    // {
    //     id: 2,
    //     role: "Front-End Development Intern",
    //     company: "GT Software, Coimbatore",
    //     duration: "April 2025 – July 2025",
    //     description: "Built responsive e-commerce interfaces and integrated RESTful APIs using React.js. Ensured mobile-first design and cross-browser compatibility.",
    //     descriptionMobile: "Built responsive e-commerce interfaces and integrated RESTful APIs using React.js."
    // }
];

export const SERVICES_DATA = [
    {
        id: 1,
        icon: <Laptop size={32} />,
        ariaLabel: "Laptop computer icon",
        title: "Full Stack Web Development",
        description: "Building modern, responsive, and high-performance full stack web applications from frontend to backend.",
        descriptionMobile: "Building modern, responsive full stack web apps."
    },
    {
        id: 2,
        icon: <Atom size={32} />,
        ariaLabel: "React atom icon",
        title: "Mobile App Development",
        description: "Creating interactive, cross-platform mobile applications for Android and iOS using React Native and Expo.",
        descriptionMobile: "Creating cross-platform mobile apps for Android and iOS."
    },
    {
        id: 3,
        icon: <Palette size={32} />,
        ariaLabel: "Artist palette icon",
        title: "UI/UX Design",
        description: "Designing visually appealing and user-centric web interfaces with clean, maintainable code.",
        descriptionMobile: "Designing user-centric, visually appealing interfaces."
    },
    {
        id: 4,
        icon: <Wrench size={32} />,
        ariaLabel: "Wrench tool icon",
        title: "Debugging & Optimization",
        description: "Improving performance and user experience through effective debugging and optimization techniques.",
        descriptionMobile: "Improving performance via debugging and optimization."
    },
    {
        id: 5,
        icon: <Globe size={32} />,
        ariaLabel: "Globe icon",
        title: "Backend & API Development",
        description: "Developing robust backend systems, databases, and integrating RESTful APIs using Node.js, Express, PHP, and MongoDB.",
        descriptionMobile: "Developing robust backend systems and RESTful APIs."
    },
    {
        id: 6,
        icon: <Rocket size={32} />,
        ariaLabel: "Rocket icon",
        title: "Responsive UI",
        description: "Designing and developing mobile-friendly interfaces optimized for all screen sizes.",
        descriptionMobile: "Designing mobile-friendly, optimized interfaces."
    }
];

export const PROJECTS_DATA = {
    frontend: [
        {
            id: 1,
            icon: <ShoppingCart size={32} />,
            title: 'E-Commerce Website',
            description: 'Front-end e-commerce platform with product pages, cart functionality, and responsive UI built using React.js, JavaScript, and CSS.',
            tags: ['React', 'JavaScript', 'CSS'],
            badge: 'Frontend',
            link: 'https://e-commerce-theta-mocha-93.vercel.app/',
        },
        {
            id: 2,
            icon: <Home size={32} />,
            title: 'Airbnb Clone Front-End',
            description: 'Modern, responsive property booking UI design with smooth animations and interactivity built with HTML, CSS, and JS.',
            tags: ['HTML', 'CSS', 'JavaScript'],
            badge: 'Frontend',
            link: 'https://airbnb-beta-six.vercel.app/'
        },
    ],
    fullstack: [
        {
            id: 4,
            icon: <ShoppingBag size={32} />,
            title: 'E-Commerce Platform',
            description: 'Complete full-stack software application for e-commerce with authentication, payments, order management, and admin dashboard built using Node.js and MongoDB.',
            tags: ['React', 'Node.js', 'MongoDB'],
            badge: 'Full Stack',
            link: 'https://luxora-eta-one.vercel.app/'
        },
    ]
};

export const TECH_ICONS = [
    { id: 1, name: 'React', src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg', className: 'tech-icon-1' },
    { id: 2, name: 'JavaScript', src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg', className: 'tech-icon-2' },
    { id: 3, name: 'HTML5', src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg', className: 'tech-icon-3' },
    { id: 4, name: 'CSS3', src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg', className: 'tech-icon-4' },
    { id: 5, name: 'Git', src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg', className: 'tech-icon-5' },
    { id: 6, name: 'NodeJS', src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg', className: 'tech-icon-6' },
    { id: 7, name: 'Figma', src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/figma/figma-original.svg', className: 'tech-icon-7' },
    { id: 8, name: 'Bootstrap', src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-original.svg', className: 'tech-icon-8' },
    { id: 9, name: 'Next.js', src: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/nextjs/nextjs-original.svg', className: 'tech-icon-9' },
    { id: 10, name: 'PHP', src: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/php/php-original.svg', className: 'tech-icon-10' },
    { id: 11, name: 'Vite', src: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/vitejs/vitejs-original.svg', className: 'tech-icon-11' }
];

export const ABOUT_DATA = {
    intro: "I am a Full Stack Software Developer capable of building complete web and mobile software solutions from frontend to backend, database, API, deployment, and maintenance.",
    description: [
        "I am a Full Stack Software Developer with experience in developing complete web and mobile applications. I work with React.js, Vite.js, and Next.js for frontend development.",
        "For backend development, I use Node.js, Express.js, and PHP, and work with MongoDB and MySQL for database management. I also develop cross-platform mobile applications using React Native and Expo for Android and iOS.",
        "I have experience working across the complete software development lifecycle, including UI development, API development, database integration, authentication, testing, debugging, deployment, and maintenance."
    ]
};

export const SKILLS_DATA = [
    { id: 1, name: "HTML / CSS / JavaScript", level: "Advanced Level", percentage: 90 },
    { id: 2, name: "React.js", level: "Advanced Level", percentage: 85 },
    { id: 3, name: "UI/UX & Responsive Design", level: "Expert Level", percentage: 95 },
    { id: 4, name: "Git & Version Control", level: "Advanced Level", percentage: 80 },
    { id: 5, name: "API Integration", level: "Intermediate Level", percentage: 75 },
    { id: 6, name: "Node.js / Express / MongoDB", level: "Intermediate Level", percentage: 85 },
    { id: 7, name: "Next.js", level: "Intermediate Level", percentage: 70 },
    { id: 8, name: "PHP / MySQL", level: "Intermediate Level", percentage: 65 },
    { id: 9, name: "Vite.js", level: "Advanced Level", percentage: 85 },
    { id: 10, name: "React Native / Expo", level: "Intermediate Level", percentage: 70 }
];

export const HERO_DATA = {
    greeting: "Hello, I'm Mowli S",
    title: "FULL STACK SOFTWARE DEVELOPER",
    description: "Full Stack Software Developer experienced in building responsive and user-friendly web and mobile applications using React.js, Next.js, Node.js, PHP, MongoDB, MySQL, React Native, and Expo. Focused on clean code, performance optimization, and scalable solutions."
};

export const CONTACT_DATA = {
    location: "Chennai, Tamil Nadu, India"
};
